export const WEB3_LIBARY = "WEB3_LIBARY";

export const WEB3_USER_INFO = "WEB3_USER_INFO";

export const IS_TEST_NET = process.env.IS_TEST_NET

export const WEB3_SDK_SUPPORT_CHAIN_ID = process.env.SDK_SUPPORT_CHAIN_ID?.split(',')

